<div class="alert alert-{{item.type}} {{item.translationIdentifier}} alert-dismissible" role="alert"
*ngFor="let item of messages.items | async; index as i" id="message-{{i}}">
    <span [innerHtml] = "'Messages.' + item.translationIdentifier|translate:item.dictionary"></span>
    <button type="button" class="btn-close" (click)="messages.delete(item.id)">
    </button>
</div>
